var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":function($event){return _vm.communicate()}}},[_vm._v("通信")])])}
var staticRenderFns = []

export { render, staticRenderFns }